import React, { useCallback, useContext, useEffect, useState } from "react";
import { Container } from "components";
import Breadcrumb from "components/molecules/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { API_URL_emailSetting } from "constants/api";
import { emailSettingReducers } from "redux/emailSettingSlice";
import { getData, putData } from "actions";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "context/AuthContext";

const Emailsettings = () => {
  const navigate = useNavigate();
  const [adminAccess, setAdminAccess] = useState(false);
  const { datauser } = useContext(AuthContext);
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [emailCollab, setEmailCollab] = useState("");
  const [sendEmailCollab, setSendEmailCollab] = useState("");
  const [attachment, setAttachment] = useState("");

  const { getEmailSettingResult, addEmailSettingResult } = useSelector(
    (state) => state.emailSetting
  );

  const get = useCallback(
    async (params) => {
      getData(
        API_URL_emailSetting,
        params,
        { dispatch, redux: emailSettingReducers },
        "GET_EMAILSETTING"
      );
    },
    [dispatch]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      all_emails: email,
      email_collaborator: emailCollab,
      attachment: attachment,
      send_email_collaborator: sendEmailCollab,
    };
    //edit on id 1
    putData(
      `${API_URL_emailSetting}1/`,
      formData,
      { dispatch, redux: emailSettingReducers },
      "ADD_EMAILSETTING",
      () => {
        fetchData();
        navigate("/administrator/email/emailsettings");
      }
    );
  };

  const fetchData = useCallback(() => {
    //get id 1 for setting
    const params = `1/`;
    get(params);
  }, [get]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (addEmailSettingResult) {
      fetchData();
    }
  }, [addEmailSettingResult, fetchData]);

  useEffect(() => {
    if (getEmailSettingResult) {
      setEmail(getEmailSettingResult.all_emails);
      setEmailCollab(getEmailSettingResult.email_collaborator);
      setAttachment(getEmailSettingResult.attachment);
      setSendEmailCollab(getEmailSettingResult.send_email_collaborator);
    }
  }, [getEmailSettingResult]);

  useEffect(() => {
    if (datauser !== "") {
      const permissionViewMenuAdmin = datauser.group_permissions.includes(
        "access_menu_admin"
      );
      if (permissionViewMenuAdmin) {
        setAdminAccess(true);
      } else {
        navigate("/dashboard/agent");
      }
    }
  }, [datauser]);

  if (!adminAccess) {
    return null;
  }

  return (
    <Container>
      <Breadcrumb
        title={"Emails"}
        excludedPaths={["email", "administrator"]}
        group={"Superadmin"}
      />
      <div className="bg-neutral dark:bg-neutral-800 rounded overflow-hidden shadow">
        <div className="h-12 w-full grid items-center px-4 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600 text-xs md:text-base">
          Email settings
        </div>
        <form onSubmit={handleSubmit}>
          <div className="h-auto w-full px-4 bg-neutral dark:bg-neutral-800 border-b border-neutral-200 dark:border-neutral-600 object-left">
            <label>
              <input
                id="email"
                type="checkbox"
                checked={email === 1}
                onChange={(e) => setEmail(e.target.checked ? 1 : 0)}
                className="form-checkbox mr-2 mt-4"
              />
              Accept all emails
            </label>
            <br />
            <label>
              <input
                id="email_collaborator"
                type="checkbox"
                checked={emailCollab === 1}
                onChange={(e) => setEmailCollab(e.target.checked ? 1 : 0)}
                className="form-checkbox mr-2 mt-4"
              />
              Accept email collaborators
            </label>
            <br />
            <label>
              <input
                id="attachments"
                type="checkbox"
                checked={attachment === 1}
                onChange={(e) => setAttachment(e.target.checked ? 1 : 0)}
                className="form-checkbox mr-2 mt-4 "
              />
              Attachments
            </label>
            <br />
            <label>
              <input
                id="send_email_collaborator"
                type="checkbox"
                checked={sendEmailCollab === 1}
                onChange={(e) => setSendEmailCollab(e.target.checked ? 1 : 0)}
                className="form-checkbox mr-2 mt-4 mb-8"
              />
              Send email collaborators
            </label>
          </div>
          <div className="h-12 w-full grid items-center px-4 bg-neutral-50 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
            <button
              type="submit"
              className="flex w-16 items-center justify-center p-1 rounded shadow-sm border text-white bg-sky-800 hover:bg-sky-700"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </Container>
  );
};

export default Emailsettings;
